import React from 'react';
import CloseIcon from '../../icons/close-large.svg';
import BackIcon from '../../icons/left-large.svg';
import './NavigationButton.scss';

export const BackButton = (props) => <BackIcon styleName="cursor" {...props} />;
export const CloseButton = (props) => <CloseIcon styleName="cursor" {...props} />;